export default {
    methods: {
        /** All methods here should have a prefix of GenericComponent for code organisation purpose. */

        genericComponentGetComponent(componentName) {
            let component = null
            let parent = this.$parent
            while (parent && !component) {
                if (parent.$options.name === componentName) {
                    component = parent
                }
                parent = parent.$parent
            }
            return component
        },
        /**
         *
         * Needs work
         *
         * @param parentComponent
         * @param childComponentName
         * @returns {boolean}
         */
        genericComponentGetChildComponent(parentComponent, childComponentName) {

            let self = this;
            let childComponent = false
            let children = parentComponent.$children
            children.forEach(function (child) {
                if (child.$options.name === childComponentName) {
                    childComponent = child
                }
            });
            return childComponent

        }
    }
}
